// extracted by mini-css-extract-plugin
export default {"root":"SpecialToolsApp_root__57mJM"};